import React, { useEffect, useState, useCallback, useMemo } from "react";
import Content from "../../../Components/Dashboard/Content/Content";
import Loader from "../../../Utils/Loader";
// import FullDataTable from "../../../Components/ExtraComponents/Datatable/FullDataTable";
import Table from "../../../Components/ExtraComponents/Tables/FullDataTable";

import {
  Get_All_TRADINGSTATUS_USER,
  user_activity_logs,
} from "../../../ReduxStore/Slice/Users/TradingStatusSlice";
import { useDispatch } from "react-redux";
import { fDateTimeSuffix } from "../../../Utils/Date_formet";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

const TradingStatus = () => {
  const dispatch = useDispatch();

  // Memoize user details to prevent re-creation on every render
  const userDetails = useMemo(() => {
    const user_details = JSON.parse(localStorage.getItem("user_details"));
    const gotodashboard = JSON.parse(localStorage.getItem("user_details_goTo"));
    const isgotodashboard = JSON.parse(localStorage.getItem("gotodashboard"));

    return {
      user_Id: isgotodashboard ? gotodashboard.user_id : user_details.user_id,
    };
  }, []);

  const [activeMainTab, setActiveMainTab] = useState("home");
  const [tradingStatusDate, setTradingStatusDate] = useState("all");
  const [updateStatusDate, setUpdateStatusDate] = useState("all");
  const [dateArray, setDateArray] = useState([]);

  // Raw data storage (fetched once)
  const [rawTradingData, setRawTradingData] = useState([]);
  const [rawUserLogs, setRawUserLogs] = useState([]);

  // Loading states
  const [tradingLoading, setTradingLoading] = useState(false);
  const [logsLoading, setLogsLoading] = useState(false);

  // Flag to track if data has been fetched
  const [tradingDataFetched, setTradingDataFetched] = useState(false);
  const [logsDataFetched, setLogsDataFetched] = useState(false);

  // Generate date array (last 5 weekdays) - only once
  const generateDateArray = useCallback(() => {
    const dates = [];
    let count = 0;
    let i = 0;

    while (count < 5) {
      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() - i);
      const dayOfWeek = currentDate.getDay();

      // if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      const formattedDate = currentDate.toISOString().split('T')[0];
      dates.push(formattedDate);
      count++;
      // }
      i++;
    }
    return dates;
  }, []);

  // Filter trading data based on selected date
  const filteredTradingData = useMemo(() => {
    if (tradingStatusDate === "all") return rawTradingData;
    return rawTradingData.filter(item =>
      item.createdAt && item.createdAt.split("T")[0] === tradingStatusDate
    );
  }, [rawTradingData, tradingStatusDate]);

  // Filter user logs based on selected date
  const filteredUserLogs = useMemo(() => {
    if (updateStatusDate === "all") return rawUserLogs;
    return rawUserLogs.filter(item => {
      if (item.createdAt) {
        const createdAtDate = new Date(item.createdAt).toISOString().split("T")[0];
        return createdAtDate === updateStatusDate;
      }
      return false;
    });
  }, [rawUserLogs, updateStatusDate]);

  // Fetch trading status data - only once
  const fetchTradingStatusData = useCallback(async () => {
    if (tradingDataFetched) return;

    try {
      setTradingLoading(true);
      const response = await dispatch(Get_All_TRADINGSTATUS_USER(userDetails)).unwrap();

      if (response.status) {
        setRawTradingData(response.data || []);
      } else {
        setRawTradingData([]);
      }
      setTradingDataFetched(true);
    } catch (error) {
      setRawTradingData([]);
      setTradingDataFetched(true);
    } finally {
      setTradingLoading(false);
    }
  }, [dispatch, userDetails, tradingDataFetched]);

  // Fetch user activity logs - only once
  const fetchUserLogsData = useCallback(async () => {
    if (logsDataFetched) return;

    try {
      setLogsLoading(true);
      const response = await dispatch(user_activity_logs(userDetails)).unwrap();

      if (response.status) {
        setRawUserLogs(response.data || []);
      } else {
        setRawUserLogs([]);
      }
      setLogsDataFetched(true);
    } catch (error) {
      console.error('Error fetching user logs:', error);
      setRawUserLogs([]);
      setLogsDataFetched(true);
    } finally {
      setLogsLoading(false);
    }
  }, [dispatch, userDetails, logsDataFetched]);

  // Initialize date array - only once
  useEffect(() => {
    const dates = generateDateArray();
    setDateArray(dates);
    setTradingStatusDate(dates[0] || "all");
    setUpdateStatusDate(dates[0] || "all");
  }, [generateDateArray]);

  // Fetch data based on active tab - only when needed
  useEffect(() => {
    if (activeMainTab === "home" && !tradingDataFetched) {
      fetchTradingStatusData();
    } else if (activeMainTab === "profile" && !logsDataFetched) {
      fetchUserLogsData();
    }
  }, [activeMainTab, fetchTradingStatusData, fetchUserLogsData, tradingDataFetched, logsDataFetched]);



  const tradingStatusColumns = [

    {
      name: "Time",
      selector: (row) => row.createdAt,
      cell: (row) => <>{fDateTimeSuffix(row.createdAt)}</>,
      sortable: true,
      // width: "200px",
    },
    {
      name: "Login Status",
      selector: (row) => row.login_status || row.trading_status || "-",
      cell: (row) => (
        <span>{row.login_status || row.trading_status || "-"}</span>
      ),
      sortable: true,
      // width: "180px",
    },
    {
      name: "Role",
      selector: (row) => row.role,
      sortable: true,
      // width: "150px",
    },
    {
      name: "System IP",
      selector: (row) => row.system_ip,
      sortable: true,
      // width: "180px",
    },
  ];




  const userLogsColumns = [

    {
      name: "Time",
      selector: (row) => row.createdAt,
      cell: (row) => <>{row.createdAt ? fDateTimeSuffix(row.createdAt) : "-"}</>,
      sortable: true,
      // width: "190px",
    },
    {
      name: "Strategy / Group",
      selector: (row) => row.Strategy,
      cell: (row) => <>{row.Strategy || "-"}</>,
      sortable: true,
      // width: "180px",
    },
    {
      name: "Update",
      selector: (row) => row.message,
      cell: (row) => <>{row.message || "-"}</>,
      sortable: true,
      // width: "250px",
    },
    {
      name: "Qty",
      selector: (row) => row.quantity,
      cell: (row) => <>{row.quantity || "-"}</>,
      sortable: true,
      // width: "100px",
    },
    {
      name: "IP",
      selector: (row) => row.system_ip,
      cell: (row) => <>{row.system_ip || "-"}</>,
      sortable: true,
      // width: "160px",
    },
    {
      name: "Device",
      selector: (row) => row.device,
      cell: (row) => <>{row.device || "-"}</>,
      sortable: true,
      // width: "150px",
    },
    {
      name: "Update By",
      selector: (row) => row.role,
      cell: (row) => <>{row.role || "-"}</>,
      sortable: true,
      // width: "150px",
    },
  ];



  return (
    <Content Page_title="Trading Status" button_status={false}>
      <Tabs
        activeKey={activeMainTab}
        onSelect={(k) => setActiveMainTab(k)}
        id="main-tabs"
        className="mb-3   "
      >
        <Tab eventKey="home" title="Panel Trading Status">
          <div className="my-4   ">
            <Tabs
              id="trading-status-date-tabs "
              activeKey={tradingStatusDate}
              onSelect={(k) => setTradingStatusDate(k)}
              className="mb-3  trading-dates-tabs"
            >
              <Tab eventKey="all" title={<span style={{ fontSize: "12px" }}>All</span>} />
              {dateArray.map((date) => (
                <Tab
                  eventKey={date}
                  title={<span style={{ fontSize: "12px" }}>{date}</span>}
                  key={date}
                />
              ))}

            </Tabs>
          </div>
          {tradingLoading ? (
            <Loader />
          ) : (
         
            <Table
              columns={tradingStatusColumns}
              data={filteredTradingData}
            />
          )}
        </Tab>

        <Tab eventKey="profile" title="Update Status">
          <div className="my-4 ">
            <Tabs
              id="update-status-date-tabs"
              activeKey={updateStatusDate}
              onSelect={(k) => setUpdateStatusDate(k)}
              className="mb-3 trading-dates-tabs"
            >
              <Tab eventKey="all" title="All" />
              {dateArray.map((date) => (
                <Tab
                  eventKey={date}
                  title={<span style={{ fontSize: "12px" }}>{date}</span>}
                  key={date}
                />
              ))}
            </Tabs>
          </div>
          {logsLoading ? (
            <Loader />
          ) : (
           
            <Table
              columns={userLogsColumns}
              data={filteredUserLogs}
            />
          )}
        </Tab>
      </Tabs>
    </Content>
  );
};

export default TradingStatus;